import { combineReducers } from 'redux';

import form from './form';
import register from './register';
import resend from './resend';

export default combineReducers({
  form,
  register,
  resend,
});
